// Callback is called with the array of return values where the indices
// correspond to those in cbList. (Order of calls is ignored.)
const parallel = function(cbList, finalCb) {
	let left = cbList.length;
	const results = Array(cbList.length);
	cbList.forEach((oneCb, i) => {
		let done = false;
		oneCb(result => {
			if (done) {
				return;
			}
			done = true;
			left -= 1;
			results[i] = result;
			if (left === 0) {
				finalCb && finalCb(results);
			}
		});
	});
	if (!cbList.length) {
		setTimeout(() => finalCb([]), 0);
	}
};

module.exports = {
	parallel,
};
